import axios from "axios";
import { useEffect, useState } from "react";
import BlogHero from "../home/BlogHero";
import BlogArticles from "../home/BlogArticles";

export default function Blog() {
  const [blog, setBlog] = useState([]);

  useEffect(() => {
    const getBlogData = async () => {
      try {
        const res = await axios.get(
          `${process.env.REACT_APP_BACKEND_BASE_URL}/blog`
        );
        if (res.status === 200) {
          setBlog(res.data.data || []);
        } else {
          setBlog([]);
        }
      } catch (err) {
        console.log(err);
        setBlog([]);
      }
    };
    getBlogData();
  }, []);

  return (
    <>
      <BlogHero />
      <BlogArticles posts={blog} />
    </>
  );
}
